<script setup lang="ts">
  defineOptions({ name: 'NotificationsAction' });
</script>

<template>
  <bv-btn
    class="h-8 w-8 p-0"
    rounded="circle"
    size="sm"
    variant="text"
  >
    <bv-icon icon="bvi-bell" />
  </bv-btn>
</template>
